import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { MenuComponent } from '../menu/menu.component';
import { feature } from '../../utils/FeaturesController';
import { OnboardingComponent } from '../onboarding/onboarding.component';
import { MatSelectChange } from '@angular/material/select';
import { ViewPath } from '../../constants/ViewPath';
import { RouterService } from '../../services/router.service';
import { SessionService } from '../../services/session.service';
import { UserService } from '../../services/user.service';
import { UserDataService } from '../../services/user-data.service';
import { ConfirmDialogService } from '../../services/confirm-dialog.service';
import { ResponsiveService } from '../../services/responsive.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MenuTriggerComponent } from '../menu/menu-trigger/menu-trigger.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgClass } from '@angular/common';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { CircularLetterComponent } from '../circular-letter/circular-letter.component';
import { greetingPhrase } from '../../constants/constants';
import { LessOrDirective } from '../../directives/screenWidth/less-or.directive';
import { IconFilledDirective } from '../../directives/icon-filled.directive';
import { SnackService } from '../../services/snack.service';
import { CustomFile } from '../../custom-classes/CustomFile';
import { M_User } from '../../models/M_User';
import { MoreThanDirective } from '../../directives/screenWidth/more-than.directive';
import { RouterModule } from '@angular/router';
import { CompanyContextService } from '../../services/company-context.service';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatToolbarModule,
    MenuTriggerComponent,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    CommonModule,
    MatMenuTrigger,
    MoreThanDirective,
    MatMenu,
    SkeletonComponent,
    CircularLetterComponent,
    LessOrDirective,
    IconFilledDirective,
    RouterModule,
    MatTooltip,
  ],
})
export class ToolbarComponent implements OnInit {
  f = feature;
  v = ViewPath;
  q: number = 0;
  hasPendFeedback: boolean = true;
  @Input() mc!: MenuComponent;
  @Input() onboarding!: OnboardingComponent;
  @Input({ required: true }) showMenuButton!: boolean;
  @Output() onclick: EventEmitter<any> = new EventEmitter<any>();
  greetingPhrase = greetingPhrase;
  companyCtxS = inject(CompanyContextService);

  constructor(
    public routerS: RouterService,
    public sessionS: SessionService,
    public userS: UserService,
    public userDataS: UserDataService,
    private confirmD: ConfirmDialogService,
    //private d: MatDialog,
    public responsiveS: ResponsiveService,
    public snackS: SnackService,
  ) {}

  ngOnInit(): void {
    const userId = this.userS.userId ? this.userS.userId.toString() : 'Unknown';
  }

  goProfile() {
    this.routerS.goTo(this.v.profile);
  }

  goDocumentation() {
    this.routerS.goTo(this.v.documentation);
  }

  onChangeCenter(val: MatSelectChange) {
    this.confirmD
      .show({
        title: 'Cambio de centro',
        body: ['Estás  a punto de cambiar de centro.', '¿Deseas proceder?'],
      })
      ?.afterClosed()
      .subscribe((res) => {
        console.log('RES LOGGED OUT', res);
        if (res == true) {
        } else {
          //val.source.writeValue(this.einaDataS.company.userCenter?.id);
        }
      });
  }

  showToolbarBigMama() {
    let role = this.userS.getRole();
    if (!role) {
      return true;
    }
    /** If the role canno't acces, just return false */
    return true;
  }

  uploadImage(data: [cf: CustomFile, u: M_User]) {
    /*this.apiS.uploadImage(data[0], "profile").then(_res => {
      this.snackS.show("¡Foto de perfil actualizada! 📸")
    })*/
    //this.profilePicrureS.onChangeProfilePicture(data);
  }

  onClickHelp() {
    this.onboarding.open();
  }

  async leaveCompany() {
    this.confirmD
      .show({
        title: 'Volver a tu empresa',
        body: [
          'Vas a volver a tu empresa base en eina, abandonando la que estás viendo en modo lectura hasta el momento.',
          '¿Deseas proceder?',
        ],
        showCancel: true,
      })
      ?.afterClosed()
      .subscribe(async (res) => {
        if (res) {
          let response: any = await this.companyCtxS.leaveCompany();
          window.open(response.redirect_url, '_blank');
          window.location.reload();
        }
      });
  }
}
